import React from 'react'
import ProductsSectionTitle from '../ProductsSectionTitle'
import { Element } from 'react-scroll'
import { Link } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'

const MEAProductFamily = () => {
  return (
    <>
      <Element
        name="MEAProductFamily"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <ProductsSectionTitle
                classes = "text-center"
                title = "MEA Product Family"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center">From ultra-low-power sensors to advanced compute systems.</p>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-product-family-card p-4">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/spark.svg`} alt="spark" />
                </div>
                <h5 className="mt-3 mb-3">MEA Spark</h5>
                <p>Compact Edge AI Engine for Industrial Environments</p>
                <p className="mb-2 d-flex align-items-center" data-tooltip-id="spark-1" data-tooltip-content="Real-time decision-making directly at the source"><img src={`${process.env.PUBLIC_URL}/images/icons/magnifying-glass.svg`} width="18px" alt="magnifying glass" />&nbsp;&nbsp;Edge AI Inference</p>
                <p className="mb-2 d-flex align-items-center" data-tooltip-id="spark-2" data-tooltip-content="Built for seamless PLC & controller integration"><img src={`${process.env.PUBLIC_URL}/images/icons/gear.svg`} width="18px" alt="gear" />&nbsp;&nbsp;Industrial-Ready</p>
                <p className="mb-4 d-flex align-items-center" data-tooltip-id="spark-3" data-tooltip-content="Expandable with analog & digital I/O modules"><img src={`${process.env.PUBLIC_URL}/images/icons/puzzle.svg`} width="18px" alt="puzzle" />&nbsp;&nbsp;Modular I/O Support</p>
                <Link className="edu-btn btn-primary btn-small w-100 text-center" to="/contact-us">Request Specs</Link>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-product-family-card p-4">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/server.svg`} alt="server" />
                </div>
                <h5 className="mt-3 mb-3">MEA Nexus</h5>
                <p>Centralized AI Hub for Distributed Edge Networks</p>
                <p className="mb-2 d-flex align-items-center" data-tooltip-id="nexus-1" data-tooltip-content="High-capacity edge compute for real-time inference and coordination"><img src={`${process.env.PUBLIC_URL}/images/icons/rocket2.svg`} width="18px" alt="rocket" />&nbsp;&nbsp;Powerful AI at the Core</p>
                <p className="mb-2 d-flex align-items-center" data-tooltip-id="nexus-2" data-tooltip-content="Scales effortlessly across multi-site and regional deployments"><img src={`${process.env.PUBLIC_URL}/images/icons/earth.svg`} width="18px" alt="earth" />&nbsp;&nbsp;Centralized Edge Orchestration</p>
                <p className="mb-4 d-flex align-items-center" data-tooltip-id="nexus-3" data-tooltip-content="Connects and manages fleets of Sparks and Gateways with precision"><img src={`${process.env.PUBLIC_URL}/images/icons/chain.svg`} width="18px" alt="chain" />&nbsp;&nbsp;Seamless Integration & Control</p>
                <Link className="edu-btn btn-primary btn-small w-100 text-center" to="/contact-us">Request Specs</Link>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-product-family-card p-4">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/globe.svg`} alt="globe" />
                </div>
                <h5 className="mt-3 mb-3">MEA Gateway</h5>
                <p>Data Collection Node with Versatile I/O Modules</p>
                <p className="mb-2 d-flex align-items-center" data-tooltip-id="gateway-1" data-tooltip-content="Connects seamlessly with Spark, Nexus, or the cloud"><img src={`${process.env.PUBLIC_URL}/images/icons/chain.svg`} width="18px" alt="chain" />&nbsp;&nbsp;Flexible Integration</p>
                <p className="mb-2 d-flex align-items-center" data-tooltip-id="gateway-2" data-tooltip-content="Customizable analog & digital input/output support"><img src={`${process.env.PUBLIC_URL}/images/icons/tools.svg`} width="18px" alt="tools" />&nbsp;&nbsp;Modular I/O Expansion</p>
                <p className="mb-4 d-flex align-items-center" data-tooltip-id="gateway-3" data-tooltip-content="Structured data relay with minimal cloud dependency"><img src={`${process.env.PUBLIC_URL}/images/icons/network-bars.svg`} width="18px" alt="network bars" />&nbsp;&nbsp;Low-Latency Edge Sync</p>
                <Link className="edu-btn btn-primary btn-small w-100 text-center" to="/contact-us">Request Specs</Link>
              </div>
            </div>
          </div>
        </div>
        <Tooltip id="spark-1" className="product-tooltip" place="top" />
        <Tooltip id="spark-2" className="product-tooltip" />
        <Tooltip id="spark-3" className="product-tooltip" />
        <Tooltip id="nexus-1" className="product-tooltip" />
        <Tooltip id="nexus-2" className="product-tooltip" />
        <Tooltip id="nexus-3" className="product-tooltip" />
        <Tooltip id="gateway-1" className="product-tooltip" />
        <Tooltip id="gateway-2" className="product-tooltip" />
        <Tooltip id="gateway-3" className="product-tooltip" />
      </Element>
    </>
  )
}

export default MEAProductFamily;